import React from "react";

function IconCoin(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.8a7.8 7.8 0 1 0 0-15.6 7.8 7.8 0 0 0 0 15.6Zm0 1.8a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Z"
        fill="currentColor"
      />
      <path
        d="M11.671 17.715h.742v-1.031c1.83-.123 3.138-1.102 3.138-2.72 0-1.412-.921-2.12-2.68-2.52l-.459-.097V9.072c.722.103 1.206.503 1.296 1.199h1.72c-.064-1.521-1.224-2.527-3.016-2.656v-1.05h-.74v1.044c-1.773.11-3.043 1.109-3.043 2.649 0 1.392.928 2.146 2.61 2.527l.432.103v2.352c-.876-.097-1.34-.554-1.444-1.212H8.5c.045 1.612 1.36 2.56 3.171 2.662v1.025Zm-1.237-7.625c0-.515.425-.934 1.237-1.03v2.113c-.87-.232-1.237-.567-1.237-1.083Zm3.32 4.074c0 .586-.446.986-1.341 1.076v-2.185c.998.252 1.34.542 1.34 1.109Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconCoin;
